import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import chronosApi from '@chronos/api-client/chronosApi';

let rawBaseQuery = null;

const dynamicBaseQuery = async (args, api, extraOptions) => {
  const baseUrl = api.getState().app.chronosApiUrl;

  if (!baseUrl) {
    return {
      error: {
        status: 400,
        statusText: 'Bad Request',
        data: 'No baseUrl',
      },
    };
  }

  if (!rawBaseQuery) {
    rawBaseQuery = fetchBaseQuery({
      baseUrl,
      prepareHeaders: (headers, { getState }) => {
        const token = getState()?.app?.chronosJWT ?? chronosApi.getJWT();

        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }

        return headers;
      },
    });
  }

  return rawBaseQuery(args, api, extraOptions);
};

export const chronosBaseApi = createApi({
  reducerPath: 'chronosApi',
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}),
});
